import * as types from '../actions/actionTypes';
import { assign } from 'lodash';

const host = window.location.hostname
const local = (host.indexOf("local") > -1);
const staging = host.indexOf('staging') > -1;
const develop = (host.indexOf('develop.') > -1)
const ROOT_URL = (local || develop)
  ? 'https://myphoto-api-develop.appspot.com'
  : (staging)
    ? 'https://myphoto-api-staging.appspot.com'
    : 'https://mp-cloud-api.appspot.com'

const initialState = {
  results: [
    {
      name: null,
      description: null,
      promoCode: null,
      startDate: null,
      endDate: null,
      discountId: 12,
      salesChannels: [0],
      maxUses: 0,
      disabled: false,
    },
  ],
  promotion: {
    name: null,
    description: null,
    promoCode: null,
    startDate: null,
    endDate: null,
    discountId: 0,
    salesChannels: [0],
    maxUses: 0,
    disabled: false,
  },
  meta: {
    count: 0,
    totalCount: 0,
    pageCount: 0,
    self: `${ROOT_URL}/promotions?page=1`,
    previous: null,
    next: null,
    first: null,
    last: null,
    page: 1,
    limit: 20,
  },
};

function promotions(state = initialState, action) {
  switch (action.type) {
    case types.PROMOTIONS_FETCH_SUCCESS:
      return assign({}, state, action.res);
    case types.PROMOTIONS_FETCH_ERROR:
    case types.PROMOTION_FETCH_ERROR:
    case types.PROMOTION_EDIT_ERROR:
    case types.PROMOTION_SET_ERROR:
    case types.PROMOTION_DISABLE_ERROR:
      return assign({}, state, {
        error: action.res,
      });
    case types.PROMOTION_FETCH_SUCCESS:
    case types.PROMOTION_EDIT_SUCCESS:
    case types.PROMOTION_SET_SUCCESS:
      return assign({}, state, {
        promotion: action.res,
      });
    case types.PROMOTION_DISABLE_SUCCESS:
      return assign({}, state, {
        promotionDisabled: action.res.ok,
      });
    case types.PROMOTION_DELETE_SUCCESS:
      return assign({}, state, {
        promotionDelete: action.res.ok,
      });
    case types.PROMOTIONS_CLEAR_ERRORS:
    case types.PROMOTION_CLEAR_ERRORS:
      return assign({}, state, {
        error: false,
      });
    default:
      return state;
  }
}

export default promotions;



// WEBPACK FOOTER //
// ./src/reducers/promotions.js